import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  entry: {
    categories: {
      data: {},
      loading: false,
      loaded: false,
    },
    services: {
      data: {},
      loading: false,
      loaded: false,
    }
  },
  promotion: {
    category: {
      data: {},
      loading: false,
      loaded: false,
    }
  }
})

const { Types, Creators } = createActions({
  getCustomization: ['payload'],
  setCustomization: ['payload'],

  setSingleCustomization: ['payload'],
  removeSingleCustomization: ['payload'],
})

export const getCustomizationReducer = (state, { payload }) =>
  state.setIn([payload.screen, payload.resource, 'loading'], true)

export const setCustomizationReducer = (state, { payload }) =>
  state
    .setIn([payload.screen, payload.resource, 'loading'], false)
    .setIn([payload.screen, payload.resource, 'loaded'], true)
    .setIn([payload.screen, payload.resource, 'data'], payload.data)

export const setSingleCustomizationReducer = (state, { payload }) =>
  state.setIn([payload.screen, payload.resource, 'data', payload.data.id], payload.data)

export const removeSingleCustomizationReducer = (state, { payload }) =>
  state.setIn([payload.screen, payload.resource, 'data'], state[payload.screen][payload.resource].data.without(payload.id))

export const appCustomizationReducer = createReducer(INITIAL_STATE, {
  [Types.GET_CUSTOMIZATION]: getCustomizationReducer,
  [Types.SET_CUSTOMIZATION]: setCustomizationReducer,

  [Types.SET_SINGLE_CUSTOMIZATION]: setSingleCustomizationReducer,
  [Types.REMOVE_SINGLE_CUSTOMIZATION]: removeSingleCustomizationReducer,
})

export const AppCustomizationTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/appCustomizationReducer.js